import { useRegulatoryTrainingMatrix } from '@/hooks/useNewRegulatoryTrainingMatrix';
import { NewRegulatoryTrainingMatrixCell } from './NewRegulatoryTrainingMatrixCell';
import { NewRegulatoryTrainingMatrixHeader } from './NewRegulatoryTrainingMatrixHeader';
import { PageNavigator } from './PageNavigator';
import ViewDataWrapper from './ViewDataWrapper';

export const NewRegulatoryTrainingMatrix = () => {
	const {
		matrix: {
			data: matrixData,
			isLoading,
			currentPage,
			setCurrentPage,
			isError,
		},
	} = useRegulatoryTrainingMatrix();
	return (
		<ViewDataWrapper isLoading={isLoading} isError={isError} noWrapper={true}>
			<div className="flex flex-col gap-4 overflow-hidden">
				<div className="flex flex-col gap-4 overflow-auto max-w-full h-full custom-scrollbar">
					{matrixData && (
						<div>
							<div className="flex flex-col gap-4">
								<table>
									<thead className="sticky top-0 bg-white z-30 ring-1 ring-[#E8EBF8] text-sm font-semibold">
										<tr className="h-28 text-primary">
											<th className="bg-[#E8EBF8] w-40 font-semibold text-left  sticky left-0 z-20">
												<div className="w-40 px-2">EMPRESA</div>
											</th>
											<th className="bg-[#E8EBF8] w-40 font-semibold text-left  sticky left-40 z-20">
												<div className="w-44 px-2">LOCAL DE TRABALHO</div>
											</th>

											<th className="bg-[#E8EBF8] w-80 font-semibold text-left  sticky left-84 z-20">
												<div className="w-80 px-2">CARGO</div>
											</th>

											{matrixData?.trainings?.map((training) => {
												return (
													<NewRegulatoryTrainingMatrixHeader
														training={training}
														key={`training-${training.id}`}
													/>
												);
											})}
										</tr>
									</thead>
									<tbody>
										{matrixData.matrix.map((row) => (
											<tr
												key={`row-${row.generalInformationJobTitle.id}-${row.workStation.id}`}
												className="h-12 border-2 text-xs bg-white  border-gray-200"
											>
												<td className="sticky left-0 z-20 bg-white">
													<div className="w-40 px-2">
														{row.generalInformationJobTitle.company.name}
													</div>
												</td>
												<td className="sticky left-40 z-20 bg-white">
													<div className="w-44 px-2">
														{row.workStation.name}
													</div>
												</td>
												<td className="sticky left-84 z-20 bg-white">
													<div className="w-80 px-2">
														{row.generalInformationJobTitle.name}
													</div>
												</td>

												{row.matrixCell.map((cell) => (
													<td
														key={`cell-${row.generalInformationJobTitle.id}-${row.workStation.id}-${cell.id}`}
														className="px-2 border-x-2 border-gray-200"
													>
														<NewRegulatoryTrainingMatrixCell cell={cell} />
													</td>
												))}
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					)}
				</div>
				{matrixData && (
					<PageNavigator
						currentPage={currentPage}
						totalPages={matrixData.meta.totalPages}
						setCurrentPage={setCurrentPage}
					/>
				)}
			</div>
		</ViewDataWrapper>
	);
};
